import { Navigate, useLocation, useRouteError } from 'react-router';

const RedirectToError = () => {
  const from = useLocation();
  const error = useRouteError();

  return (
    <Navigate
      replace
      state={{ error, from }}
      to="/error"
    />
  );
};

export default RedirectToError;
